import { render, staticRenderFns } from "./TwitterAlert.vue?vue&type=template&id=21380f6d&"
import script from "./TwitterAlert.vue?vue&type=script&lang=js&"
export * from "./TwitterAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports